module.exports = __webpack_public_path__ + "img/search.f3dd8534.svg";